import { api, apiRequest, buildWcUrl, getPaginationFromHeaders, PaginationHeaders } from './api';
import { Tag, QueryParams } from '../types/woocommerce';

export interface TagsResponse {
  tags: Tag[];
  pagination: PaginationHeaders;
}

export interface TagQueryParams extends QueryParams {
  hide_empty?: boolean;
  product?: number;
}

// Service pour les tags (collections)
export const tagsService = {
  // Récupérer tous les tags avec pagination
  async getTags(params?: TagQueryParams): Promise<TagsResponse> {
    const response = await api.get<Tag[]>(buildWcUrl('products/tags'), { params });
    
    return {
      tags: response.data,
      pagination: getPaginationFromHeaders(response.headers),
    };
  },

  // Récupérer un tag par ID
  async getTag(id: number): Promise<Tag> {
    return apiRequest.get<Tag>(buildWcUrl(`products/tags/${id}`));
  },

  // Récupérer un tag par slug
  async getTagBySlug(slug: string): Promise<Tag> {
    const response = await api.get<Tag[]>(buildWcUrl('products/tags'), {
      params: { slug },
    });
    if (response.data.length === 0) {
      throw new Error('Tag non trouvé');
    }
    return response.data[0];
  },

  // Récupérer tous les tags (sans pagination)
  async getAllTags(): Promise<Tag[]> {
    let allTags: Tag[] = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await api.get<Tag[]>(buildWcUrl('products/tags'), {
        params: { page, per_page: 100 }
      });
      allTags = [...allTags, ...response.data];
      hasMore = page < getPaginationFromHeaders(response.headers).totalPages;
      page++;
    }

    return allTags;
  },
};

